module.exports = __webpack_public_path__ + "img/2.19f29f21.jpg";